import { render, staticRenderFns } from "./productFlowComponent.vue?vue&type=template&id=26508a1e&scoped=true&"
import script from "./productFlowComponent.vue?vue&type=script&lang=js&"
export * from "./productFlowComponent.vue?vue&type=script&lang=js&"
import style0 from "./productFlowComponent.vue?vue&type=style&index=0&id=26508a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26508a1e",
  null
  
)

export default component.exports